import useSWR from 'swr'

import { useAuthStore } from '@/store/auth'

import { getAuthRoleFlags } from './roles'
import { USER } from '@/api/endpoints'
import { User } from '@/api/users/types'

export const useAuthRoles = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const {
    data: user,
    error: userError,
    isLoading: isLoadingUser,
    mutate: mutateUser
  } = useSWR<User>(isAuthenticated ? USER.PROFILE : null)
  const { isAdmin, isOwner, isManager, isUser, isPostCreator } = getAuthRoleFlags(user)

  return {
    user,
    userError,
    isAuthenticated,
    isLoadingUser,
    mutateUser,
    isAdmin,
    isOwner,
    isManager,
    isUser,
    isPostCreator
  }
}
